<template>
  <div class="home">
	  
	<swiper id="swiperBox" v-bind:options="swiperOption">
		<swiper-slide>
			  <div class="slide-one" >
				<div style="position: absolute;"><img src="../assets/img/logok.png" style="height: 100px;"></div>
				<div  class="wow bounceInRight" style="width: 95%; height: 100px; line-height: 100px; font-size: 18px; color: #ffffff; top: 0px; border-bottom: 1px solid #e7e8ea;margin-left: 5%;">
					<div style="float: left;font-size: 30px;">
						<div class="wow bounceInLeft"   data-wow-delay="2s" style="float: left; height: 98px; width: 50px; border-bottom: 3px solid #0b3678;"></div>
						<div class="wow bounceInLeft"   data-wow-delay="1.5s" style="width: 300px; height: 70px;position: absolute;line-height: 70px; color: #2c2c2c;">典范项目</div>
						<div class="wow bounceInLeft"   data-wow-delay="1s" style="width: 300px; height: 30px;position: absolute;font-size: 16px; margin-top: 50px;line-height: 40px; color: #626262;">创意与先锋俱进 成就价值</div>
						
					</div>
					<div style="float: right; width: 150px; height: 100px; text-align:center;line-height: 110px;"></div>
					<div @click="zhaopin" class="chuyang wow bounceInDown" data-wow-delay="1.7s" :style="chufa6" @mouseover="chufa(6)">精英招聘</div>
					<div @click="lianxi" class="chuyang wow bounceInDown" data-wow-delay="1.5s" :style="chufa5" @mouseover="chufa(5)">朗建之窗</div>
					<div class="chuyang wow bounceInDown"  data-wow-delay="1.2s" :style="chufa4" @mouseover="chufa(4)">典范项目</div>
					<div @click="fuwu" class="chuyang wow bounceInDown"  data-wow-delay="1s" :style="chufa3" @mouseover="chufa(3)">服务范围</div>
					<div @click="aboutsb" class="chuyang wow bounceInDown"   data-wow-delay="0.7s" :style="chufa2"  @mouseover="chufa(2)">关于我们</div>
					<div  @click="homes" class="chuyang wow bounceInDown"  data-wow-delay="0.5s" :style="chufa1" @mouseover="chufa(1)">网站首页</div>
					
				 </div>
				 
				 <div class="zhongbu">
					 <div style="width: 94%; position: absolute;top: 0px;height: 40px; line-height: 42px; z-index: 0; margin-left: 3%;">
					 	<div  class="wow bounceInLeft"   data-wow-delay="2.2s" style=" background: #FFFFFF; width: 30px;height: 50px; float:left;text-align: left;cursor: pointer;" @click="getScrollLeft"> <img src="../assets/img/zuojt.png" style="width: 20px;"/> </div>
					 	<div  class="wow bounceInLeft"   data-wow-delay="2.5s" style=" background: #FFFFFF; width: 30px;height: 50px; float:right;text-align: right;cursor: pointer;" @click="getScrollRight"> <img src="../assets/img/youjt.png" style="width: 20px;"/> </div>
					 </div>
					<div  class="selectlist wow bounceInDown" data-wow-delay="2s" style="overflow:hidden;  overflow-x:none;position: absolute;z-index: 1;">
						
					
							<haverster-slidingMenu :list="list" :color="color" @changes="getIndex"></haverster-slidingMenu>
							<!--div class="contentList"><img :src="imageList[activeIndex]" mode="" /></div-->
				
						
						<!--ul style=" white-space: nowrap; width: 2600px;">						
							<li style="font-weight: bold;color: #d70d19;display: inline-block;">建筑设计</li>
							<li>城市规划（总归、控规、修规）</li>
							<li>城市设计与建筑实施策略</li>
							<li>景观设计</li>
							<li>环境与生态规划研究</li>
							<li>旅游度假区规划设计与研究</li>
							<li>战略与经济规划</li>
							<li>项目策划</li>
							<li>专项规划与实施策略研究</li>
							<li>交通体系规划与研究</li>
							<li>市政设计</li>
							<li style="background: #FFFFFF;"></li>
						</ul-->
						
						
						
						
					</div>
					
					<!--瀑布流数据-->
					<div class="innerbox wow fadeIn"  data-wow-delay="3s" data-wow-duration="3s"  style="width: 90%; margin-left: 5%; height: 80%; margin-top: 60px; overflow-x: hidden; overflow-y: scroll;">
						
						<waterfall :waterfallData="waterfallData"></waterfall>
						
					</div>
					
					
				 </div>
				
			</div>
			
			 <foder class="wow fadeInUp"  data-wow-delay="2.5s"></foder>
		</swiper-slide>
		
    </swiper>

	
	

	
  </div>
  
  
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import foder from "../components/foder";
import haversterSlidingMenu from '../components/haverster-slidingMenu/haversterSlidingMenu.vue';
import waterfall from '../components/kcy-waterfall/waterfall';
import photo from "../components/photo";
//header
import WOW from 'wowjs';
export default {
  components: {
	  swiper,
	  swiperSlide,
	  haversterSlidingMenu,
	  waterfall,
	  foder,
	  photo
  },
  data() {
    return {
		list: [], //默认传到顶部菜单栏的数据
		activeIndex: '280', ///菜单栏选中状态的index值
		color: '#ffffff', //设置菜单的背景颜色
		isShow:true,
		//windowHeight: document.documentElement.clientHeight/2,   //实时屏幕高度
		formMess:{
			    "account":"",
			    "phone":"",
				"key":"DAS54sadqwe451FGH54asHGJdfSAD",
				"content":""
			},
	waterfallData:[
			{
			  e_img: require('../../src/assets/img/pbl02_03.jpg'),
			  e_intro: "描述信息",
			},
			{
			  e_img: require('../../src/assets/img/pbl02_05.jpg'),
			  e_intro: "描述信息",
			},
			{
		      e_img: require('../../src/assets/img/pbl02_07.jpg'),
		      e_intro: "描述信息",
			},
			{
		      e_img: require('../../src/assets/img/pbl02_09.jpg'),
		      e_intro: "描述信息",
			},
			{
			  e_img: require('../../src/assets/img/pbl02_19.jpg'),
			  e_intro: "描述信息",
			},
			{
			  e_img: require('../../src/assets/img/pbl02_15.jpg'),
			  e_intro: "描述信息",
			},
			{
			  e_img: require('../../src/assets/img/pbl02_21.jpg'),
			  e_intro: "描述信息",
			},
			{
			  e_img: require('../../src/assets/img/pbl02_13.jpg'),
			  e_intro: "描述信息",
			},
			
	   ],
      loading: true,
	  abouts:'加载中...',
	  html:'',
	  chufa1:'border-bottom:  rgba(255,255,255,0.2)',
	  chufa2:'border-bottom:  rgba(255,255,255,0.2)',
	  chufa3:'border-bottom:  rgba(255,255,255,0.2)',
	  chufa4:'color: #0b3678',
	  chufa5:'border-bottom:  rgba(255,255,255,0.2)',
	  chufa6:'border-bottom:  rgba(255,255,255,0.2)',
      caseList: [],
	  youceimages:'',
	  newsinfo:'',
	  newsother:'',
	  backgrounda:require('../../src/assets/img/fwfw1.jpg'),
	  backgroundb:require('../../src/assets/img/fwfw2.jpg'),
	  backgroundc:require('../../src/assets/img/fwfw3.jpg'),
	  backgroundd:require('../../src/assets/img/fwfw4.jpg'),
	  cpimages:require('../../src/assets/img/cp_1.png'),
	       newsList: [],
	      swiperOption: {
	        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        direction: "vertical", //水平方向移动
	        grabCursor: false, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
	        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
	        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
	        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
	        mousewheel: false, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
	        mousewheelControl: false, //同上
	        height: window.innerHeight, // 高度设置，占满设备高度  如果加导航的话在此基础上减6
	        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
	        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
	  		pagination: {
	  		    el: '.swiper-pagination',//点击切换
	  			clickable :true,
	  		  },
	        on: {
	  			
	          //监听滑动切换事件，返回swiper对象
	          slideChange: () => {
	            let swiper = this.$refs.mySwiper.swiper;
	            console.log(swiper.activeIndex); //滑动打印当前索引
	  			if(swiper.activeIndex==1){
	  				//////new WOW.WOW().init();
	  				new WOW.WOW({
	  					  boxClass: 'wow',
	  					  animateClass: 'animate__animated',
	  					  offset: 20,
	  					  mobile: true,
	  					  live: true,
	  					  callback: null,
	  					  scrollContainer: false
	  				}).init();
	  			}
	  			if(swiper.activeIndex==2){
	  				//////new WOW.WOW().init();
	  				new WOW.WOW({
	  					  boxClass: 'wow',
	  					  animateClass: 'animate__animated',
	  					  offset: 30,
	  					  mobile: true,
	  					  live: true,
	  					  callback: null,
	  					  scrollContainer: false
	  				}).init();
	  			}
	  			
	          }
	        },
	  		
	  		
	  		
	      }
    };
  },
  methods:{
	  
	  getIndex(e) {
	  	this.activeIndex = e;
		console.log(e);
		this.$http
		  .get(`home/splist?id=${e}`)
		  .then(response => {
		   // console.log(response);
			console.log(response.data.message);
		    this.waterfallData = response.data.message;
		    //window.console.log(this.newsList);
		  })
		  .catch(function(error) {
		    window.console.log(error);
		  });
	  },
	  zhaopin(){
	  	this.$router.push('/zhaopin')
	  },
	  getScrollLeft(){
		  var getLeft = document.getElementsByClassName('selectlist')[0]
		  getLeft.scrollLeft -= 50
	  },
	  getScrollRight(){
	  		  var getRight = document.getElementsByClassName('selectlist')[0]
	  		  getRight.scrollLeft += 50
	  },
	  
	  getScrollUp(){
	  		  var getLeft = document.getElementsByClassName('innerbox')[0]
	  		  getLeft.scrollLeft -= 50
	  },
	  getScrollDown(){
	  		  var getLeft = document.getElementsByClassName('innerbox')[0]
	  		  getLeft.scrollLeft -= 50
	  },
	  
	  homes(){
	  	this.$router.push('/')
	  },
	  aboutsb(){
		  this.$router.push('/abouts')
	  },
	  fuwu(){
	  	this.$router.push('/fuwu')
	  },
	  lianxi(){
	  	this.$router.push('/lianxi')
	  },
	  english(){
		  window.location.href = 'https://en.sdzkjd.cn/';
	  },
	  news(){
	  	this.$router.push('/news')
	  },
	  products(e){
	  	this.$router.push('/Product/'+e)
	  },
	  product(){
	  	this.$router.push('/Product')
	  		},
	chufa(e){
		//console.log(e);
		
	    if(e==1){
	       this.chufa1="color: #0b3678"
	    }else{
	      this.chufa1="border-bottom:  rgba(255,255,255,0.2)"
	    }
	    if(e==2){
			//console.log(11111)
	      this.chufa2="color: #0b3678"
	    }else{
	        this.chufa2="border-bottom:  rgba(255,255,255,0.2)"
	    }
	    if(e==3){
	       this.chufa3="color: #0b3678"
	    }else{
	          this.chufa3="border-bottom:  rgba(255,255,255,0.2)"
		}
	    if(e==4){
	          this.chufa4="color: #0b3678"
	    }else{
	       this.chufa4="border-bottom:  rgba(255,255,255,0.2)"
		}
	    if(e==5){
	       this.chufa5="color: #0b3678"
	    }else{
	       this.chufa5="border-bottom:  rgba(255,255,255,0.2)"
	    }
		if(e==6){
			
		   this.chufa6=""
		}else{
		   this.chufa6="border-bottom:  rgba(255,255,255,0.2)"
		}
	},  
  },
  computed: {
  	  
    swiper() {
  		//////new WOW.WOW().init();
      return this.$refs.mySwiper.swiper;
    }
  	
  },
  mounted() {
	  this.$http
	    .get(`home/splist?id=${this.activeIndex}`)
	    .then(response => {
	      console.log(response);
	  	console.log(response.data.message);
	      this.waterfallData = response.data.message;
	      //window.console.log(this.newsList);
	    })
	    .catch(function(error) {
	      window.console.log(error);
	    });
	  
	  this.$http
	    .get("home/cplist")
	    .then(response => {
	  	  //console.log(response.data);
	  	  this.list = response.data.message;	  
	  	  
	    })
	    .catch(function(error) {
	  	 // console.log(error);
	      //window.console.log(error);
	    });
	  
	  
    this.$http
      .get("home/cplist")
      .then(response => {
		  //console.log(response.data);
		  this.list = response.data.message;	  
		  
      })
      .catch(function(error) {
		 // console.log(error);
        //window.console.log(error);
      });
	  
	  new WOW.WOW({
	  	  boxClass: 'wow',
	  	  animateClass: 'animate__animated',
	  	  offset: 60,
	  	  mobile: true,
	  	  live: true,
	  	  callback: null,
	  	  scrollContainer: false
	  }).init();
  }
};
</script>

 <style lang="scss" scoped>
	 li {
		 float: left;
		 list-style:none;
		 background: #ffffff;
		 margin-right: 30px;
		 font-size: 16px;
		 padding: 10px 30px;
		 border-radius: 10px;
		 color: #000000;
		 cursor: pointer;
		 }
		 .contentList {
		 	width: 750rpx;
		 	height: 1334rpx;
		 	margin-top: 20rpx;
		 }
		 .contentList image {
		 	width: 100%;
		 	height: 100%;
		 }
		   /*滚动条样式*/
		         .innerbox::-webkit-scrollbar {
		             width: 4px;    
		             /*height: 4px;*/
		         }
		         .innerbox::-webkit-scrollbar-thumb {
		             border-radius: 10px;
		             -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		             background: rgb(11, 54, 120);
		         }
		         .innerbox::-webkit-scrollbar-track {
		             -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		             border-radius: 0;
		             background: rgba(0,0,0,0.1);
		 
		         }
		 .content {
		 		text-align: center;
		 		height: 200px;
		 	}
		 .noList::-webkit-scrollbar{
			 height: 0;
		 }
		 .noList{
			 display: flex;
			 padding:0px 0px;
			 overflow-x: scroll;
			 width: 100%;
			 margin: 30px 70px;
			 z-index:300;
		 }
		 .selectlist{
			     height: 50px;
			     width: 90%;
			     margin-left: 5%;
		 }
	 .zhongjian{
		 width: 24%; 
		 height: 600px; 
		 margin-left: 0.8%; 
		 float: left;
		 ;
	 }
	 .zhongbu{
		 width: 100%;
		 height: 70%;
		 margin: 0px auto;
		 position: absolute;
		 top:16%;
	 }
	 .bttitle{
	 	font-size: 20px;
	 	color: #ffffff;
	 	width: 100%;
	 	text-align: left;
	 }
	 .btlist{
	 	margin-top: 20px;
	 	font-size: 18px;
	 	color: #7b7979;
	 	width: 100%;
	 	text-align: left;
	 }
	 .ceshisf{
	 	cursor: pointer;
	 	transform-origin:left;
	 	//transform:scaleX(1);
	 	transition: all 0.4s;
	 	height: 107px; 
	 	line-height: 100px; 
	 }
	 .ceshisf:hover{
	 	transform:scaleX(1);
	 	transform-origin:left;
	 	
	 }
	 .chuyang{
	 	float: right; width: 150px;text-align: center;
		 color: #2d2d2d;
		 border-bottom: 1px solid #0b3678;cursor: pointer;
	 }
	 .slide-one {
	   background-size: 100% 100%;
	       background: #ffffff;
	 }
	 .aboutbj{
		 background-size: 100% 100%;
	 }
	 .forbodyl{
	 	width: 100%;
	 	height: 960px; 
	 	margin: 0px auto;	
	 }
	 .swiper-slide {
	   font-size: 24px;
	   // text-align: center;
	   // line-height: 100px;
	   display: flex;
	   flex-direction: column;
	   align-content: center;
	 
	   .page {
	     text-align: center;
	     height: 150px;
	     overflow: hidden;
	     h3,
	     p {
	       font-size: 40px;
	       font-weight: 400;
	       color: #fff;
	     }
	   }
	 
	   .slogan {
	     text-align: center;
	     font-size: 50px;
	     color: #fff;
	   }
	 }
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>